import request from "../../services/general-server";

export default {
  // 获取医生列表
  findStaffList: data => {
    return request({
      url: "/user/findStaffList",
      method: "post",
      data
    });
  },
  // 获取地区列表
  findAreaList: data => {
    return request({
      url: "/user/findAreaList",
      method: "post",
      data
    });
  },
  //获取科室列表
  findStandDepList: data => {
    return request({
      url: "/user/findStandDepList",
      method: "post",
      data
    });
  },
  //获取医生职称列表
  findStaffTitle: data => {
    return request({
      url: "/user/findStaffTitle",
      method: "post",
      data
    });
  },
  //banner
  getBanners: data => {
    return request({
      url: "/user/getBanners",
      method: "post",
      data
    });
  },
  //根据关键字查询科室
  searchDepByName: data => {
    return request({
      url: "/user/searchDepByName",
      method: "post",
      data
    });
  },
  // 获取关注列表
  getFollowList: data => {
    return request({
      url: "/user/getFollowList",
      method: "post",
      data
    });
  },
  // 关注、取消关注
  follow: data => {
    return request({
      url: "/user/follow",
      method: "post",
      data
    });
  },
  // 根据名称查询机构、科室、医生
  searchByName: data => {
    return request({
      url: "/user/searchByName",
      method: "post",
      data
    });
  },
  // 获取复诊、咨询记录
  getConsultList: data => {
    return request({
      url: "/user/getConsultList",
      method: "post",
      data
    });
  },
  // 获取处方记录
  getRecipeList: data => {
    return request({
      url: "/user/getRecipeList",
      method: "post",
      data
    });
  },
  // 获取检验检查记录
  getInspectList: data => {
    return request({
      url: "/user/getInspectList",
      method: "post",
      data
    });
  },
  // 获取医院列表
  findOrgList: data => {
    return request({
      url: "/user/findOrgList",
      method: "post",
      data
    });
  },
  // 获取复诊、咨询详情
  getConsultDetail: data => {
    return request({
      url: "/user/getConsultDetail",
      method: "post",
      data
    });
  },
  // 新增投诉
  complain: data => {
    return request({
      url: "/user/complain",
      method: "post",
      data
    });
  },
  // 获取投诉详情
  complainDetail: data => {
    return request({
      url: "/user/complainDetail",
      method: "post",
      data
    });
  },
  // 图片上传
  uploadImage: data => {
    return request({
      url: "/user/uploadImage",
      method: "post",
      data,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  },
  //获取医生当前服务状态
  getDoctorStatus: data => {
    return request({
      url: "/user/getDoctorStatus",
      method: "post",
      data
    });
  },
  //投诉二次反馈
  reComplain: data => {
    return request({
      url: "/user/reComplain",
      method: "post",
      data
    });
  },
  //获取影像系统跳转地址
  getImgTfhdcEncUrl: data => {
    return request({
      url: "/user/getImgTfhdcEncUrl",
      method: "post",
      data
    });
  },

  //获取电子健康卡详情
  getEhealthCardDetail: data => {
    return request({
      url: "/user/getEhealthCardDetail",
      method: "post",
      data
    });
  },
  //首页活动列表
  activitiesList: data => {
    return request({
      url: "/user/activitiesList",
      method: "post",
      data
    });
  },
  //活动医生列表
  activitieDoctorsList: data => {
    return request({
      url: "/user/activitieDoctorsList",
      method: "post",
      data
    });
  },
  //活动详情
  activitieDetail: data => {
    return request({
      url: "/user/activitieDetail",
      method: "post",
      data
    });
  },
  //活动问诊列表
  activitieConsList: data => {
    return request({
      url: "/user/activitieConsList",
      method: "post",
      data
    });
  },
  //活动点击统计
  activitieClick: data => {
    return request({
      url: "/user/activitieClick",
      method: "post",
      data
    });
  },
  //活动文章分类列表
  activitieArticleTypeList: data => {
    return request({
      url: "/user/activitieArticleTypeList",
      method: "post",
      data
    });
  },
  //活动文章列表
  activitieArticlesList: data => {
    return request({
      url: "/user/activitieArticlesList",
      method: "post",
      data
    });
  },
  //活动文章详情
  activitieArticlesDetail: data => {
    return request({
      url: "/user/activitieArticlesDetail",
      method: "post",
      data
    });
  },
  //js授权
  getWxConfigInfo: data => {
    return request({
      url: "/zyywx/getWxConfigInfo",
      method: "post",
      data
    });
  },
  // 获取医生电子证照
  staffElecCert: data => {
    return request({
      url: "/user/staffElecCert",
      method: "post",
      data
    });
  },
  // 判断医生是否有剩余号源
  staffLeftNumberSource: data => {
    return request({
      url: "/user/staffLeftNumberSource",
      method: "post",
      data
    });
  },
    registerHealthCard: data => {
        return request({
            url: "/platform/registerHealthCard",
            method: "post",
            data
        });
    },
  // 获取分院列表
  getSpList: data => {
    return request({
      url: "/user/getSpList",
      method: "post",
      data
    });
  },
  // 获取openId
  getOpenId: data => {
    return request({
      url: "/user/getOpenId",
      method: "post",
      data
    });
  },
  // 电子健康卡列表
  getHealthCardList : data => {
    return request({
      url: "/user/getHealthCardList",
      method: "post",
      data
    });
  },
  // 电子健康卡二维码
  getHealthCardQRCode: data => {
    return request({
      url: "/user/getHealthCardQRCode",
      method: "post",
      data
    });
  },
  // 注册电子健康卡
  registerHealthCard: data => {
    return request({
      url: "/user/registerHealthCard",
      method: "post",
      data
    });
  },
  // 解绑电子健康卡
  deleteHealthCard: data => {
    return request({
      url: "/user/deleteHealthCard",
      method: "post",
      data
    });
  },
  // 设置默认电子健康卡
  setDefaultHealthCard: data => {
    return request({
      url: "/user/setDefaultHealthCard",
      method: "post",
      data
    });
  },
  // jsapi
  getWxConfig: data => {
    return request({
      url: "/user/getWxConfig",
      method: "post",
      data
    });
  },
  // 根据跳转携带健康卡id获取电子健康卡列表
  bundingHealthCard: data => {
    return request({
      url: "/user/bundingHealthCard",
      method: "post",
      data
    });
  },
  // 获取预约挂号医院列表
  getYyghOrgList: data => {
    return request({
      url: "/user/getYyghOrgList",
      method: "post",
      data
    });
  },
  // 获取挂号记录列表
  getYyghRecord: data => {
    return request({
      url: "/user/getYyghRecord",
      method: "post",
      data
    });
  },
  // 获取挂号记录详情
  getYyghDetail: data => {
    return request({
      url: "/user/getYyghDetail",
      method: "post",
      data
    });
  },

  // 健康达州用户互通接口
  getJkdzUserInfo: data => {
    return request({
      url: "/user/getJkdzUserInfo",
      method: "post",
      data
    });
  },
  // 获取多元咨询配置模块
  getConfigureModule:data=>{
    return request({
      url: "/user/findSerblockList",
      method: "post",
      data
    });
  },
};



// WEBPACK FOOTER //
// ./src/api/general-hospital/general-hospital.js